import { ref } from "vue";

const showSignInModal = ref<boolean>();
const showSignUpModal = ref<boolean>();

export function useAuthModals() {
  return { showSignInModal, showSignUpModal }
};
